export default __webpack_public_path__ + "static/media/google_slides_icon.d153d480.png";